import React from "react";
import { Container, Typography, Box, Grid } from "@mui/material";
import Link from '@mui/material/Link';
import { useT } from "contexts/TranslationContext";
export default function Footer() {
  const t = useT();
  return (
    <Grid container component="footer" bgcolor="grey.100">
      <Grid item xs={12} sx={{ py: 4, borderTop: "1px solid #eee" }}>
    <Box >
      <Container sx={{ textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} {t("footer.copy")}
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          Privacy Policy
        </Typography> */}
        <Typography variant="body2" color="text.secondary">
          {/* link to term */}
          <Link
            href="/terms-of-service"
            sx={{ color: "black", textDecoration: "none" }}
          >
            {t("footer.terms")}
          </Link>
        </Typography>
        <br/>
        <Typography variant="body2" color="text.secondary">
          Photo by{" "}
          <Link
            href="https://www.pexels.com/photo/black-twin-bell-alarm-desk-clock-on-table-714701/"
            sx={{ color: "gray", textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            JESHOOTS.com
          </Link>{" "}
          from Pexels
        </Typography>
      </Container>
    </Box>
    </Grid>
    </Grid>
  );
}
